export default {
  /** alert 메시지 */
  ALERT_RETRY: '잠시 후 다시 시도해주시길 바랍니다.',
  ALERT_SUBMIT_CANCEL_SUCCESS: '취소가 완료되었습니다.',
  ALERT_SUBMIT_SAVE_SUCCESS: '참가 신청이 완료되었습니다.',
  ALERT_SUBMIT_SAVE_SINGAPORE_SUCCESS: '"2023 회계연도 뉴 에메랄드 스페셜 워크숍 싱가포르" 행사 참가신청이 완료되었습니다.',
  ALERT_SUBMIT_SAVE_SYDNEY_INFO_SUCCESS: '"2023 회계연도 시드니 다이아몬드 인비테이셔널" 행사 참가신청이 완료 되었습니다. 10월 6일(금) 오전 10시부터 액티비티 신청이 가능하며, 액티비티별 인원 제한이 있으니 안내문을 잘 확인하시어 액티비티 신청 부탁드립니다.',
  ALERT_SUBMIT_SAVE_SYDNEY_ACTIVITY_SUCCESS: '"2023 회계연도 시드니 다이아몬드 인비테이셔널" 행사 액티비티 신청이 완료 되었습니다. 액티비티 신청 접수 마감은 10월 15일(일) 자정까지로, 신청 내용 변경을 원하시는 경우 기간 내 수정해주시기 바랍니다.',
  ALERT_SUBMIT_SAVE_SAPPORO_INFO_SUCCESS: '"2023 회계연도 삿포로 리더십 세미나” 행사 참가신청이 완료 되었습니다. 액티비티 정보와 신청기간은 추후 맞춤메시지를 통해 안내드릴 예정이오니 참고해주시기 바랍니다.',
  ALERT_SUBMIT_SAVE_SAPPORO_ACTIVITY_SUCCESS: '“2023 회계연도 삿포로 리더십 세미나” 액티비티 신청이 완료되었습니다. 액티비티 신청 접수 마감일은 1월 12일(금) 자정까지이며, 신청 내용 변경을 원하시는 경우, 수정하기를 클릭하여 기간 내 수정을 완료해 주시기 바랍니다.',
  ALERT_SUBMIT_INFO_SUCCESS: '참가신청 취소가 정상적으로 접수 되었습니다.',
  ALERT_SUBMIT_ACTIVITY_SUCCESS: '참가신청 및 액티비티 취소가 정상적으로 접수 되었습니다.',
  ALERT_ACTIVITY_NO_REMAINING: '{0} {1} 액티비티의 잔여석이 부족합니다. 다시 선택해주시기 바랍니다.',
  ALERT_PAYMENT_CARD: 'ABO님들의 소중한 개인정보 보호를 위해 모든 결제는 ARS 결제로 진행됩니다.추후 발송되는 결제요청 문자의 발신번호로 전화를 걸어 안내멘트에 따라 ARS 결제 진행 부탁드립니다.결제요청 문자는 1월부터 순차적으로 발송될 예정입니다.',
  ALERT_FAMILY_INPUT_MORE: '마지막 동반가족의 입력정보를 모두 입력해 주시기 바랍니다.',
  ALERT_FAMILY_PERSON_LIMIT: '참석인원은 최대 8명까지만 가능합니다.',
  /** confirm 메시지 */
  CONFIRM_DELETE_FILE: '파일을 삭제하면 되돌릴 수 없습니다. 정말로 삭제하시겠습니까?',
  CONFIRM_REMOVE_FAMILY: '동반가족 {0}을 삭제하시겠습니까?',
  CONFIRM_ATTENDANT_RULE1: 'ABO 본인 포함 최대 4명 참석 가능하며, 조당 3명까지 무료 참석가능합니다.\n4번째 가족 구성원 부터는 추가 금액이 발생되는데 추가하시겠습니까?',
  CONFIRM_ATTENDANT_RULE2: '리더십 세미나는 ABO 본인 포함 최대 4명 참석 가능하며, 조당 3명까지 무료 참석 가능합니다.\n4번째 가족 구성원의 추가 금액은 SMTOWN TRAVEL로 지급해 주시고, 지급이 확인이 되어야 신청이 완료 됨을 양지 하여 주시기 바랍니다.',
  CONFIRM_ATTENDANT_RULE3: '동반가족은 최대 4명(ABO 본인, 부사업자 및 비사업배우자 포함)까지만 참여 가능하며, 동반가족이 직계 자녀 (자녀의 배우자 제외)로만 구성된 경우 4명을 초과할 수 있습니다.\n4번째 가족 구성원 부터는 추가 금액이 발생됩니다. 추가하시겠습니까? ',
  CONFIRM_ATTENDANT_RULE4: '동반가족 최대 인원수가 초과되었습니다. 동반가족은 최대 4명(ABO 본인, 부사업자 및 비사업배우자 포함)까지만 참여 가능하며, 동반가족이 직계 자녀(자녀의 배우자 제외)로만 구성된 경우 4명을 초과할 수 있습니다.',
  /** validation error 메시지 */
  NAME_EMPTY: '{0}님의 이름은 필수 입력사항입니다.',
  PAYMENT_TYPE: '{0}님의 결제방식을 선택해주세요.',
  PAYMENT_REMARK_CREDIT: '{0}님의 결제링크를 수신할 연락처를 적어 주세요.',
  PAYMENT_REMARK_DIRECT: '{0}님의 입금자명을 적어 주세요.',
  ATTACHMENT_EMPTY: '{0}님의 {1} 파일을 첨부해주세요.',
  RAWDATA_EMPTY: '{0}님의 {1}을(를) 입력해주세요.',
  HAS_ERROR: '{0}님의 {1} 정보가 올바르지 않습니다.',
  HAS_ERROR_BOARD_SIZE: '{0}님의 신발 사이즈 195mm 이하는 스키만 선택이 가능합니다.',
  CONSENT_EMPTY: '{0}님이 참가 필수 약관 동의 여부를 체크하지 않으셨습니다.',
  CONSENT_NOT_AGREE: '{0}님은 필수 약관을 동의하지 않으셔서 행사 참여가 불가능합니다.',
  CONSENT_OPTIONAL_EMPTY: '{0}님이 참가 선택 약관 동의 여부를 체크하지 않으셨습니다.',
  FAMILY_PAYMENT_EMPTY: '{0}님의 결제 정보를 입력하세요.',
  FAMILY_OVER_PERSON: '{0}님의 동반가족 최대 인원수가 초과되었습니다.직계자녀를 제외한 최대 4명(ABO, 배우자 포함)까지만 참여 가능합니다.',
  COMMON_DATA_EMPTY: '{0} 파일을 첨부해주세요.',
  SCHEDULE_EMPTY: '{0}님의 {1} 귀국일 신청해주시길 바랍니다.',
  ACTIVITY_EMPTY: '{0}님의 {1} 액티비티를 신청해주시길 바랍니다.',
  ACTIVITY_NUMBER: '{0}님의 {1} {2} 액티비티의 참여 인원을 선택해주세요.',
  ACTIVITY_TEXT_EMPTY: '{0}님의 {1} {2} 액티비티의 실제 사용자를 입력해주세요.',
  ACTIVITY_TEXT_INVALID: '{0}님의 {1} {2} 액티비티의 실제 사용자를 "이름(회원번호)" 형식으로 입력해주세요.',
  ACTIVITY_LIMIT_EXCEED: '{0} {1} 액티비티의 잔여 인원을 초과하였습니다.',
  ACTIVITY_VIP_COUNT_REMAIN: 'VIP {0} 액티비티 선택 가능한 인원 {1}명 남았습니다.',
  /** api error 메시지 */
  ERROR_INVALID: '정상적인 접근이 아닙니다.',
  ERROR_AUTHORIZE: '죄송합니다. 처리가 지연되고 있습니다.\n다시 시도해 주세요.',
  ERROR_SURVEY_NOT_FOUND: '존재하지 않는 설문입니다.',
  ERROR_SURVEY_NOT_OPENED: '설문이 오픈되지 않았습니다.',
  ERROR_SURVEY_ALREADY_CLOSED: '<2023 회계연도 삿포로 리더십 세미나> 참가 및 액티비티 신청이 종료되었습니다.\n문의 사항은 담당 여행사(SM C&C, 02-2022-6520)나 카카오톡 채널(2023 암웨이 삿포로)로 연락해 주시기 바랍니다.',
  ERROR_SURVEY_NOT_PERMITTED: '설문 대상자가 아닙니다.',
  ERROR_SURVEY_RESPONSE_NOT_EXIST: '설문 응답이 존재하지 않습니다.',
  ERROR_ABO_SEARCH_ERROR: '사용자 정보 조회 중 에러가 발생했습니다.',
  ERROR_PIN_SEARCH_ERROR: '사용자 등급 조회 중 에러가 발생했습니다.',
  ERROR_DEFAULT: '처리 중 에러가 발생했습니다.\n다시 시도해 주세요.',
  ERROR_ALREADY_JOINED : '신청내역이 존재합니다.',  
  ERROR_FILE_NOT_FOUND: '신청 완료 후 다운로드 가능합니다.',
  ERROR_FILE_MISSING: '신청 완료 후 다운로드 가능합니다.',
};


// WEBPACK FOOTER //
// ./src/utils/message.js